import React, { Component } from "react";
import { withRouter, } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando, setMensagensNaoLidas } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import {getMessagemErro} from "../../utils/erro";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

import api from "../../services/api";
import { ModalMensagem } from "./ModalMensagem";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando, setMensagensNaoLidas }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

export const SolicitacaoComunicacaoInBox =

// router
withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			this.state = {
				criterioPesquisa: {
					lidas: '',
				},
				mensagem: {},
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				botoesHabilitados : true,
				exibeDetalhesMensagem: false,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.exibeMensagem = this.exibeMensagem.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.fechaModal = this.fechaModal.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Mensagens</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			
			this.executaPesquisaPaginada();
		}

		renderForm() {
			const { criterioPesquisa, resultadoPesquisa, pesquisaExecutada } = this.state;
			const { content } = resultadoPesquisa;
			const { lidas } = criterioPesquisa;

			return(
				<div className="container-fluid">

					<ModalMensagem titulo="Confirmação" 
						visible={this.state.exibeDetalhesMensagem}
						handleClose={() => this.fechaModal()}
						mensagem={this.state.mensagem}/>

					<div className="br-form">
						<div className="row">
							<div className="col-sd">
								<div className="field">
									<div className="input">
										<label htmlFor="consumidora">Situação:</label>
										<SelectSearch
											id="lidas"
											name="lidas"
											options={[{ value: true, label: 'Lidas' }, { value: false, label: 'Não lidas' }]}
											includeAllOption={true}
											onChange={this.handleInputChange}
											value={lidas}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					
						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
												<th scope="col" style={{width: "10%"}}>Número do Comunicado</th>
												<th scope="col" style={{width: "10%"}}>Data do Envio</th>
												<th scope="col" style={{width: "65%"}}>Assunto</th>
												<th scope="col" style={{width: "5%"}}>Lida</th>
												<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((mensagem, index) =>
													<tr key={index} >
														<td>{mensagem.numeroSolicitacao}</td>
														<td>{mensagem.dataEnvioComunicacao}</td>
														<td>{mensagem.assunto}</td>
														<td>{mensagem.lida ? 'Sim' : 'Não'}</td>
														<td className="text-center">
															<div className="actions">
																<button type="button" onClick={() => this.exibeMensagem(mensagem)}  
																	disabled={!this.state.botoesHabilitados}  
																	title="Visualizar mensagem">
																		<span className="sr-only">Visualizar mensagem</span>
																		<FontAwesomeIcon icon={faMagnifyingGlass} style={{color: "#1351b4"}} />
																</button>
															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhuma mensagem encontrada com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa[nome] = valor;
			this.setState((prevState) => ({ ...prevState,  criterioPesquisa }));
		}

		handleOrgaoChange(evento){
			const valor = evento.target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa['orgao'] = valor;
			criterioPesquisa['gestor'] = '';
			this.setState((prevState) => ({ ...prevState,  criterioPesquisa }));
			this.carregarGestores(this.state.criterioPesquisa.solicitacao, valor);
		}

		executarPesquisaAnterior(state) {
			const lastState = state ?? this.props.filters[this.props.location.pathname];

			this.setState((prevState) => ({ ...prevState, 
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}), () => {
				if (lastState) {
					const previousPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(previousPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada (pagina){
			const {criterioPesquisa} = this.state;
			criterioPesquisa['pagina'] = pagina;
			const url = '/api/mensagem-gestor/inbox/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState((prevState) => (
					{ ...prevState, 
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}), () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as mensagens. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();

			this.setState((prevState) => (
				{ ...prevState, 
					criterioPesquisa: {
						lidas: '',
					},
					resultadoPesquisa: {},
					pesquisaExecutada: false,
					exibeDetalhesMensagem: false,
					botoesHabilitados : true,
				}), () => {
					this.props.deleteState(this.state, this.props.location.pathname);
				}
			)
		}

		exibeMensagem(mensagem){
			this.setState((prevState) => ({ ...prevState, mensagem, exibeDetalhesMensagem: true}));

			if(!mensagem.lida) {
				api.put(`/api/mensagem-gestor/le/${mensagem.id}`)
					.then(response => { 
						const mensagensNaoLidas = response.data;
						this.props.setMensagensNaoLidas(mensagensNaoLidas);
					})
					.catch(erro => {
						const msg = getMessagemErro("Não foi possível marcar a mensagem como lida.", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					})
					.then (() =>{
						this.setState((prevState) => ({ ...prevState, botoesHabilitados:true}));
						this.props.escondeAguardando();
					});
			}	
		}
		
		fechaModal () {
			this.setState((prevState) => ({ ...prevState, exibeDetalhesMensagem: false, }));
			this.executaPesquisaPaginada();
		}
		
	}

) // redux
); // router